<template>
<div :class="{'content-main':true}">
    <div class="left-main">
        <div class="title"><span class="colorFB092B">国际</span><span>物流服务</span></div>
        <div class="sec-title">致力于完善物流一体化运营设施，包括定舱系统，仓储，陆路运输，沿海运输，报关报检服务，电子操作系统服务。<br>
            为物流企业提供全面的物流平台，为项目客户不断优化的物流解决方案，让客户的物流安全，高效，增值。</div>
        <div class="text-video-box">
            <div class="info-box">
                <swiper :options="swiperOption" ref="swiper">
                    <div class="swiper-button-prev" slot="button-prev" @click="changImgPrev"></div>
                    <div class="swiper-button-next" slot="button-next" @click="changImg"></div>
                    <swiper-slide class="swiper-slide text-boxs" v-for="(item,index) in textList" :key="index">
                        <div class="info-title">{{item.title}}</div>
                        <div class="info-text">{{item.text}}</div>
                        <div class="btns-go" @click="openForm">立即咨询</div>
                    </swiper-slide>
                </swiper>
                <div class="imgs-list">
                    <div class="imgs-child" v-for="(item,index) in imgsList" :key="index">
                        <img :src="item.icon" alt="" width="100%" >
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
    <div class="user-popuer" v-if="showPopuer">
        <div class="close-icon-box" @click="closeForm">
            <img src="../assets/images/close_2.png" alt="" width="100%" height="100%">
        </div>
        <div class="left-box">
            <div class="title-left">贸易需求发布 极速为你解决</div>
            <div class="sec-title">提交后我们将快速响应您的贸易需求</div>
            <div class="labels-box mgt15 ">姓名</div>
            <el-input placeholder="请输入您的姓名" v-model="name" width="80%"></el-input>
            <div class="labels-box mgt15 ">手机号码</div>
            <el-input placeholder="便于业务人员联系及接收告知信息" v-model="name" width="80%"></el-input>
            <div class="labels-box mgt15">需要业务</div>
            <el-select class="select-box" v-model="value" filterable placeholder="快速选择您需要办理的业务，也可直接输入" width="80%">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <div class="labels-box mgt15 ">企业名称</div>
            <el-input placeholder="请输入您的企业名称" v-model="name" width="80%"></el-input>
            <div class="mgt50 submit-btn" @click="goPage">确认发布</div>
        </div>
        <div class="right-box">
            <div class="right-title">您信赖的选择</div>
            <div class="right-text">为你提供高效专业服务</div>
            <div class="list-right-box">
                <div class="item-box">
                    <img src="../assets/images/icon_6.png" alt="" width="40px" height="40px">
                    <div class="item-child-box">
                        <div class="main-title">需求急速响应</div>
                        <div class="info-text">业务全程服务</div>
                    </div>
                </div>
                <div class="item-box">
                    <img src="../assets/images/icon_7.png" alt="" width="40px" height="40px">
                    <div class="item-child-box">
                        <div class="main-title">标准化全程服务</div>
                        <div class="info-text">最优解决方案提供</div>
                    </div>
                </div>
                <div class="item-box">
                    <img src="../assets/images/icon_8.png" alt="" width="40px" height="40px">
                    <div class="item-child-box">
                        <div class="main-title">金融风控</div>
                        <div class="info-text">风险把控</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
export default {
    name: "tagLog",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            value: "",
            list: [],
            currindex: 0,
            name: "",
            currSwiper: null,
            imgsList: [{
                id: 0,
                icon: require("../assets/images/log_1.jpg")
            }, {
                id: 1,
                icon: require("../assets/images/log_2.jpg")
            }, {
                id: 2,
                icon: require("../assets/images/log_3.jpg")
            }, {
                id: 3,
                icon: require("../assets/images/log_4.jpg")
            }],
            swiperOption: {
                slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量; 设置为auto则自动根据slides的宽度来设定数量
                centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
                spaceBetween: 30,
                //显示分页
                pagination: {
                    el: '.swiper-pagination'
                },
                //设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                //自动轮播
                //开启循环模式
                loop: false
            },
            options: [{
                value: '选项1',
                label: '出口报税'
            }, {
                value: '选项2',
                label: '跨境物流'
            }, {
                value: '选项3',
                label: '通关报税'
            }],
            showPopuer: false,
            textList: [{
                id: 0,
                title: "公路运输",
                text: "全国7个大区，覆盖28个港口，近26000条线路，专线服务； 集装箱、散装车、保税监管车辆长期通达成都及各主要地市。",
                isShow: true,
            }, {
                id: 1,
                title: "海路运输",
                text: "为外贸企业提供海运整柜及拼箱服务，目前与船公司合作，已开通中国多个港口至美洲、欧洲等多地区的航线。",
                isShow: false
            }, {
                id: 2,
                title: "铁路运输",
                text: "国内铁路订舱操作、车皮申请，国际中欧班列，中亚班列专线优势。",
                isShow: false
            }, {
                id: 3,
                title: "航空运输",
                text: "为外贸企业提供国际专线、国际小包、国际快递等航空运输服务，涉及多家航空公司的诸多航线，同时货物可实时跟踪查询。",
                isShow: false,
            }],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata");

    },
    mounted() {
        this.currindex = 0;
    },
    methods: {
        changImg(e) {
            let child = this.imgsList.shift();
            this.imgsList.push(child)
        },
        changImgPrev() {
            let child = this.imgsList.pop();
            this.imgsList.unshift(child)
        },
        closeForm() {
            this.showPopuer = false;
        },
        openForm() {
            this.showPopuer = true;
        },
        last() {
            this.textList.forEach((item, index) => {
                let currId = null;
                if (item.isShow == true) {
                    currId = item.id
                }
                item.isShow = false;
                if (item.id == currId && currId == 0) {
                    console.log(item.id, currId);
                    console.log(this.textList[2])
                    this.$set(this.textList, 2, {
                        id: 2,
                        title: item.title,
                        text: item.text,
                        isShow: true
                    })
                }

            })
            console.log(this.textList)
        },
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.user-popuer {
    .close-icon-box {
        position: absolute;
        top: -40px;
        right: 10px;
        width: 36px;
        width: 36px;

    }

    position: absolute;
    width: 620px;
    height: 560px;
    padding: 40px;
    background: #FFFFFF;
    border-radius: 0px 16px 0px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-box {
        width: 50%;
        height: 100%;
        //border: 1px red solid;

        .title-left {
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: 33px;
        }

        .sec-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin-bottom: 30px;
        }

        .labels-box {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #000000;
            line-height: 20px;
            margin-bottom: 10px;
        }

        .submit-btn {
            width: 100%;
            margin-top: 30px;
            color: white;
            height: 50px;
            background-color: #CC1F37;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .select-box {
            //border:1px red solid;
            width: 100%;
        }
    }

    .right-box {
        width: 45%;
        height: 100%;
        padding-top: 16px;
        padding-left: 29px;
        display: flex;
        flex-direction: column;

        .right-title {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF6600;
            line-height: 28px;
        }

        .right-text {
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 28px;
            margin-bottom: 20px;
        }

        .list-right-box {
            width: 100%;
            //border: 1px red solid;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            //background-color: #ccc;
            border-radius: 5px;
            margin-top: 30px;

            .item-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 30px;

                .item-child-box {
                    margin-left: 26px;

                    .main-title {
                        font-size: 15px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        line-height: 21px;
                    }

                    .info-text {
                        font-size: 13px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 18px;
                    }
                }
            }
        }

        //border: 1px red solid;
    }
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    //border: 1px red solid;

    .left-main {
        width: 1440px;
        //border:1px red solid;
        height: 100%;
        //background-color: #ccc;
        //padding-left: 240px;
        display: flex;
        flex-direction: column;
    }

    .right-main {
        width: 30px;
        height: 100%;
        padding-right: 60px;
        position: absolute;
        top: 0;
        right: 0;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.title {
    margin-top: 80px;
    color: #fff;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 84px;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.75);
    line-height: 26px;
}

.text-video-box_log {
    margin-top: 50px;
    display: flex;
    flex: 1;
    //border: 1px red solid;
    //min-height: 360px;
    justify-content: space-between;
    align-items: flex-start;

    .info-box {
        width: 496px;
        height: 480px;
        //border: 1px red solid;
        background: linear-gradient(135deg, #CC1F37 0%, rgba(152, 0, 35, 0) 100%);
        border-radius: 0px 16px 0px 16px;
        padding-top: 62px;
        padding-left: 80px;
        padding-right: 150px;
        display: flex;
        flex-direction: column;
        position: relative;

        .swiper-container {
            width: 100%;
            height: 100%;

            //border:1px red solid;
            overflow: hidden;

            .swiper-wrapper {
                //width: 200px !important;
                overflow: hidden;
                //border:1px red solid;
            }

            .swiper-slide {
                //width: 400px !important;
                //border: 1px red solid;
            }

            .swiper-button-next {
                top: 7% !important;
                right: 1%;
                color: white;
                width: 32px !important;
                height: 32px !important;
            }

            .swiper-button-prev {
                //color:white;
                top: 7% !important;
                left: 646px !important;
                color: white;
                width: 32px !important;
                height: 32px !important;
            }

            .swiper-button-prev::after {
                width: 32px !important;
                height: 32px !important;
            }

            .swiper-button-next:after {
                width: 32px !important;
                height: 32px !important;
            }
        }

        .info-title {
            font-size: 30px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 42px;
            margin-top: 35px;
            margin-bottom: 40px;
        }

        .info-text {
            width: 272px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 30px;
            margin-bottom: 40px;
        }

        .btns-go {
            width: 118px;
            height: 42px;
            background: #FFFFFF;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #B10F2C;
            line-height: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .imgs-list {
            width: 980px;
            height: 320px;
            position: absolute;
            top: 120px;
            right: -690px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            //border: 1px red solid;
            .imgs-child {
                width: 320px;
                height: 100%;
                margin-right: 15px;

                &:last-child {
                    margin-right: 0;
                }

                //border:1px red solid;
            }
        }

    }
}

.video-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    //border: 1px red solid;
    display: flex;
    min-height: 360px;
    justify-content: center;
    align-items: center;
}

.text-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    min-height: 360px;
    //border: 1px red solid;
    padding: 0 20px;

}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FB092B;
    line-height: 42px;
    margin-bottom: 40px;
}

.text {
    width: 640px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    text-align: justify;
    line-height: 32px;
}

.mgb40 {
    margin-bottom: 40px;
}

.mgt15 {
    margin-top: 15px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/tagLog.vue